import * as React from 'react';
import classNames from 'classnames';
import {PropsWithChildren} from "react";

export interface ICheckboxListProps extends PropsWithChildren {
    /** Display as inline */
    isInline?: boolean;
    hasColumns?: boolean;
    columnCount?: number;
    isElevated?: boolean;
    className?: string;
    theme?: 'theme01' | 'theme02';
    prefix?: React.ReactNode;
    suffix?: React.ReactNode;
}

const CheckboxList: React.FunctionComponent<ICheckboxListProps> = (props) => {
    const required = <span className="text-intent-danger">*</span>;
    const Elem = props.prefix || props.suffix ? null : 'div';
    return (
        <ul
            role="radiogroup"
            className={ classNames(
                props.className,
                {
                    'checkboxes' : !props.theme || props.theme==='theme01',
                    'checkboxes02': props.theme==='theme02',
                    'inline' : props.isInline,
                    'in2cols': props.hasColumns && (!props.columnCount || props.columnCount===2),
                    'in3cols': props.hasColumns && props.columnCount===3,
                    'elevated': props.isElevated,
                }
            )}
        >
            {props.prefix && (
                <li className="checkboxes__prefix">{props.prefix}</li>
            )}
            {React.Children.map(props.children, (child: any, i) => {
                return (<li key={i}>{child}</li>);
            })}
            {props.suffix && (
                <li className="checkboxes__suffix">{props.suffix}</li>
            )}
        </ul>

    );
};

CheckboxList.displayName = 'CheckboxList';

export default CheckboxList;
